import { ReactNode } from 'react';
import authStore from 'shared/auth/authStore';

const IfHasPermission = ({ permission, organizationId, children }: { permission: string; organizationId?: number | null; children: ReactNode }) => {
  const hasPermission = authStore.hasPermission(permission, organizationId);

  if (hasPermission) {
    return <>{children}</>;
  }

  return null;
};

export default IfHasPermission;
